const VAT_DEFAULT = 0.24;
const VAT_RATES: { [key: number]: number | { [key: number]: number } } = {
    2023: 0.2,
    2025: {
        6: 0.22,
    },
};

const isMapRate = (rate: number | { [key: number]: number }): rate is { [key: number]: number } => {
    return typeof rate === "object" && !Array.isArray(rate);
};

export const getVAT = () => {
    const now = new Date();
    const year = now.getFullYear();
    const rates = VAT_RATES[year];
    if (isMapRate(rates)) {
        const month = now.getMonth() + 1;
        return rates[month] ?? VAT_DEFAULT;
    }
    return rates ?? VAT_DEFAULT;
};
